import React from "react";
import styles from './styles.module.scss';
import Layout from "Layout";
import { UsersTable } from "./UsersTable";
import { FormattedMessage } from "react-intl";


export const UserRoles = () => {
  return (
    <Layout>
      <div className={styles.manageUsersAndRoles}>
        <h3><FormattedMessage id="manageUsersAndRoles" defaultMessage="Manage Users and Roles"/></h3>
        <UsersTable/>
      </div>
    </Layout>
  );
}
